import { Box } from '@material-ui/core';
import styled from 'styled-components';

export const ColorPickerContainer = styled(Box)`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-around;
  min-width: 90px;
  min-height: 35px;
  background-color: #eee;
  border-radius: 5px;
  padding: 2px 5px;
  // Add transition when box is opened
`;

export const ColorPickerHeader = styled(Box)`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  width: 100%;
  cursor: pointer;
`;

export const ColorBox = styled(Box)`
  width: 20px;
  height: 20px;
  border-radius: 5px;
  background-color: ${(props) => props.color || '#fff'};
`;

export const Divider = styled(Box)`
  width: 10px;
`;
